import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f0fa8cca&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=f0fa8cca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fa8cca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0fa8cca')) {
      api.createRecord('f0fa8cca', component.options)
    } else {
      api.reload('f0fa8cca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f0fa8cca&scoped=true&", function () {
      api.rerender('f0fa8cca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apply/region/search/index.vue"
export default component.exports